import React, { memo } from "react";
import { Table } from "react-bootstrap";

const NumericalInstructions = () => {
  return (
    <div>
      <h5>Student-produced response directions</h5>
      <ul className="mt-3">
        <li>
          If you find <b>more than one correct answer</b>, enter only one
          answer.
        </li>
        <li>
          You can enter up to 5 characters for a <b>positive</b> answer and up
          to 6 characters (including the negative sign) for a <b>negative</b>{" "}
          answer.
        </li>
        <li>
          If your answer is a <b>fraction</b> that doesn't fit in the provided
          space, enter the decimal equivalent.
        </li>
        <li>
          If your answer is a <b>decimal</b> that doesn't fit in the provided
          space, enter it by truncating or rounding at the fourth digit.
        </li>
        <li>
          If your answer is a <b>mixed number</b> (such as 3½), enter it as an
          improper fraction (7/2) or its decimal equivalent (3.5).
        </li>
        <li>
          Don't enter <b>symbols</b> such as a percent sign, comma, or dollar
          sign.
        </li>
      </ul>

      {/* Table */}
      <h3>Answer Examples</h3>
      <Table
        bordered
        style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}
      >
        <thead>
          <tr>
            <th>Answer</th>
            <th>Acceptable ways to enter answer</th>
            <th>Unacceptable: will NOT recieve credit</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>3.5</td>
            <td>
              <span>3.5</span>
              <br />
              <span>3.50</span>
              <br />
              <span>7/2</span>
            </td>
            <td>
              <span>31/2</span>
              <br />
              <span>3{"   "}1/2</span>
            </td>
          </tr>
          <tr>
            <td>2/3</td>
            <td>
              <span>2/3</span>
              <br />
              <span>.6666</span>
              <br />
              <span>.6667</span>
              <br />
              <span>0.666</span>
              <br />
              <span>0.667</span>
            </td>
            <td>
              <span>0.66</span>
              <br />
              <span>.66</span>
              <br />
              <span>0.67</span>
              <br />
              <span>.67</span>
            </td>
          </tr>
          <tr>
            <td>-1/3</td>
            <td>
              <span>-1/3</span>
              <br />
              <span>-.3333</span>
              <br />
              <span>-0.333</span>
            </td>
            <td>
              <span>-.33</span>
              <br />
              <span>-0.33</span>
            </td>
          </tr>
          {/* Add more rows as needed */}
        </tbody>
      </Table>
    </div>
  );
};

export default memo(NumericalInstructions);
